import {getAmplitudeInquirySource} from "../../application/tracking/amplitude/get_amplitude_inquiry_source";
import {IAmplitudeLeadFormTrackingContext} from "../../application/types/lead/IAmplitudeLeadFormEventTracking";
import {ApplicationSource} from "../../application/utils/form/application_form_source";
import {PromotionDetail} from "../types/PromotionDetail";

interface IParams {
    promotions: PromotionDetail[];
    offerId: number;
    propertyId?: number;
    applicationSource: ApplicationSource;
    ctaText: string;
}

export const getAmplitudePromotionsLeadFormTrackingContext = (params: IParams): IAmplitudeLeadFormTrackingContext => {
    const {promotions, offerId, propertyId, applicationSource, ctaText} = params;
    const location = propertyId != null ? "property_page" : "investment_page";

    return {
        inquiry_source: getAmplitudeInquirySource(applicationSource),
        cta_text: ctaText,
        form_location: location,
        source_id: applicationSource,
        lead_type: "single_lead",
        item_id: offerId,
        ...(propertyId != null && {property_id: propertyId}),
        promotion_id: promotions.map((promotion) => promotion.id),
        promotion_name: promotions.map((promotion) => promotion.name),
        creative_name: "Promocje",
        promotion_content: promotions.map((promotion) => promotion.description ?? "brak opisu")
    };
};
import {getAmplitudeInquirySource} from "../../application/tracking/amplitude/get_amplitude_inquiry_source";
import {IAmplitudeLeadFormTrackingContext} from "../../application/types/lead/IAmplitudeLeadFormEventTracking";
import {ApplicationSource} from "../../application/utils/form/application_form_source";
import {PromotionDetail} from "../types/PromotionDetail";

interface IParams {
    promotions: PromotionDetail[];
    offerId: number;
    propertyId?: number;
    applicationSource: ApplicationSource;
    ctaText: string;
}

export const getAmplitudePromotionsLeadFormTrackingContext = (params: IParams): IAmplitudeLeadFormTrackingContext => {
    const {promotions, offerId, propertyId, applicationSource, ctaText} = params;
    const location = propertyId != null ? "property_page" : "investment_page";

    return {
        inquiry_source: getAmplitudeInquirySource(applicationSource),
        cta_text: ctaText,
        form_location: location,
        source_id: applicationSource,
        lead_type: "single_lead",
        item_id: offerId,
        ...(propertyId != null && {property_id: propertyId}),
        promotion_id: promotions.map((promotion) => promotion.id),
        promotion_name: promotions.map((promotion) => promotion.name),
        creative_name: "Promocje",
        promotion_content: promotions.map((promotion) => promotion.description ?? "brak opisu")
    };
};
